import { useCallback } from 'react';

import type { PerimeterXEnforcerChallengeWithBlockedUrl } from '@change-corgi/core/perimeterx';

import { usePerimeterXTracking } from '#src/app/shared/hooks/payments';
import { usePerimeterXCaptcha } from '#src/app/shared/hooks/perimeterX';

// Identifies this flow in the px_captcha_* analytics, matching the convention used by the other
// protected flows (corgi_promote, corgi_sign, ...).
const FORM = 'corgi_ambassadors_contract';

/**
 * Wraps `usePerimeterXCaptcha()` with the shared challenge analytics. Unlike the payment/login
 * wrappers it returns whether the challenge was solved, which useContractForm needs for its single
 * retry.
 */
export function useContractFormPerimeterXCaptcha(): ({
	pxResponse,
}: {
	pxResponse: PerimeterXEnforcerChallengeWithBlockedUrl;
}) => Promise<boolean> {
	const { trackFailure, trackSuccess, trackShow } = usePerimeterXTracking(FORM);

	const triggerCaptcha = usePerimeterXCaptcha();

	return useCallback(
		async ({ pxResponse }) => {
			trackShow();
			const solved = await triggerCaptcha({ pxResponse });
			if (solved) {
				trackSuccess(pxResponse);
			} else {
				trackFailure(pxResponse);
			}
			return solved;
		},
		[triggerCaptcha, trackShow, trackFailure, trackSuccess],
	);
}
